import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
  RecaptchaVerifier,
  signInWithPhoneNumber,
  PhoneAuthProvider,
  signInWithCredential,
  signInWithCustomToken,
  signOut,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDn6n6VsEle1Keerh69nolPo_M5UJg4pRs",
  authDomain: "pukaar-001.firebaseapp.com",
  projectId: "pukaar-001",
  storageBucket: "pukaar-001.firebasestorage.app",
  messagingSenderId: "522647628527",
  appId: "1:522647628527:web:fe4d370efb9da2fde5091a",
  measurementId: "G-VSSESS01KJ",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export {
  auth,
  provider,
  GoogleAuthProvider,
  RecaptchaVerifier,
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
  signInWithPhoneNumber,
  PhoneAuthProvider,
  signInWithCredential,
  signInWithCustomToken,
  signOut,
};
